import assetUtils, { Asset } from 'app-lib/assetUtils'
import providerUtils from 'app-lib/providerUtils'
import { BigNumber } from '@0x/utils'
import { FulcrumProvider } from '../../../fulcrum/src/services/FulcrumProvider'
import { ChainId } from '../config/chains/chainCommon'

export enum Migration {
  BZRX_TO_OOKI = 'BZRX_TO_OOKI',
}

export interface IMigration {
  id: Migration
  fromAsset: Asset
  toAsset: Asset
  conversionRatio: number
  chainsAvailable: [1, 137]
  chains: Partial<
    Record<ChainId, { chainId: ChainId; converterAddress: string; limitedLiquidity: boolean }>
  >
}

export const migrationList: Record<Migration, IMigration> = {
  BZRX_TO_OOKI: {
    id: Migration.BZRX_TO_OOKI,
    fromAsset: Asset.BZRX,
    toAsset: Asset.OOKI,
    conversionRatio: 10,
    chainsAvailable: [1, 137],
    chains: {
      1: {
        chainId: 1,
        converterAddress: '0x6BE9B7406260B6B6db79a1D4997e7f8f5c9D7400',
        limitedLiquidity: false,
      },
      137: {
        chainId: 137,
        converterAddress: '0xc749E8217679817D07f47d1Bb1b651B05c7Cd44F',
        limitedLiquidity: true,
      },
    },
  },
}

export default class MigrateService {
  fulcrumProvider: FulcrumProvider

  /**
   * Get contracts dependencies, throws an error if something is missing
   */
  public getDependenciesStrict(migration: IMigration) {
    const deps = providerUtils.getDependenciesStrict(this.fulcrumProvider)
    const migrationContractAddress = migration.chains[deps.chainId]?.converterAddress
    if (!migrationContractAddress) {
      throw new Error('Missing migrationContractAddress')
    }
    const swapConverter = deps.contractsSource.getFixedSwapConverter(migrationContractAddress)
    return { ...deps, swapConverter }
  }

  /**
   * This is for FixedSwapConverter (BZRX -> OOKI)
   */
  migrate(migration: IMigration, amount: BigNumber) {
    const { userAddress, swapConverter, chainId } = this.getDependenciesStrict(migration)
    const decimals = assetUtils.getDecimals(chainId, migration.fromAsset)
    const amountInBaseUnits = amount.times(10 ** decimals)
    return providerUtils.runTx(
      this.fulcrumProvider,
      swapConverter.convert2(userAddress, amountInBaseUnits),
      swapConverter
    )
  }

  constructor(provider: FulcrumProvider) {
    this.fulcrumProvider = provider
  }
}
